// @flow
import { authenticatedFetch } from '../../../api/request';

export default async function setNotificationSettingsAllPush(enabled: boolean) {
    return await authenticatedFetch(`/v5/notifications/settings/setAllPush`, {
        method: 'PUT',
        body: JSON.stringify({
            enabled
        })
    });
}



// WEBPACK FOOTER //
// ./src/v5/notificationSettings/api/setNotificationSettingsAllPush.js